
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { POSTS } from './mock-posts';

@Injectable({
  providedIn: 'root'
})
export class WordpressService {
  wpURL = 'https://www.explorerstc.com/wp-json/wp/v2';
  posts: any;

  constructor(private http: HttpClient) {
    this.posts = POSTS;
  }

  getPosts(): Observable<any[]> {
    // return this.posts;
    // this.posts = this.http.get<any[]>(`${this.wpURL}/posts`, {
    //   params: {
    //     per_page: '6'
    //   }
    // });
    // return this.posts;
    return of([]);
  }

  getItem(id: number) {
    return this.http.get<any[]>(`${this.wpURL}/posts/${id}`);
  }
  getPage(id: number) {
    return this.http.get<any[]>(`${this.wpURL}/pages/${id}`);
  }
}
